var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCurrency40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_16640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3975 34.3215C16.483 34.3215 19.795 31.0095 19.795 26.924C19.795 22.8385 16.483 19.5265 12.3975 19.5265C8.31198 19.5265 5 22.8385 5 26.924C5 31.0095 8.31198 34.3215 12.3975 34.3215Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8648 34.3215C31.9503 34.3215 35.2623 31.0095 35.2623 26.924C35.2623 22.8385 31.9503 19.5265 27.8648 19.5265C23.7793 19.5265 20.4673 22.8385 20.4673 26.924C20.4673 31.0095 23.7793 34.3215 27.8648 34.3215Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7955 21.5477C23.881 21.5477 27.193 18.2357 27.193 14.1502C27.193 10.0647 23.881 6.75269 19.7955 6.75269C15.7099 6.75269 12.3979 10.0647 12.3979 14.1502C12.3979 18.2357 15.7099 21.5477 19.7955 21.5477Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6411 26.2927H27.6059",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6411 27.9827H27.6059",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.829 24.9181C29.4016 24.4208 28.8602 24.1721 28.2048 24.1721C27.2218 24.1721 25.7524 24.9181 25.7524 27.1369C25.7524 29.3557 27.1234 30.1017 28.2048 30.1017C28.9258 30.1017 29.4672 29.8616 29.829 29.3813",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8935 29.7315H9.44629C10.8242 29.159 11.2918 28.3593 10.849 27.3325C10.1847 25.7923 10.2358 24.7426 10.9334 24.1977C11.6311 23.6528 12.4185 23.6528 13.2572 24.3081",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44629 26.766H13.1523",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7949 18.1849V13.4774",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6007 14.7026H22.0479",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6007 16.5027H22.0479",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.106 10.7875L19.7805 13.4775L22.486 10.7875",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_16640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCurrency40);
export default __webpack_public_path__ + "static/media/pictogramBeaconCurrency40.cfd934a07dc872e41a38139a961789ff.svg";
export { ForwardRef as ReactComponent };